import qs from "qs";

import { UrlProvider } from "../api/UrlProvider";
import firstParam from "./firstParam";
import { NOTIFICATION_TYPES } from "./getStockPageSectionFromNotificationType";
import { LOCKED_SETTINGS_QUERY_KEY } from "./UniversalTable/lockedSettings";

export const AUTOMATIC_STRATEGY_NATIVE_SCENE = {
  SID_SIGNALS: "sidDashboardSignals",
  SUPPLY_DEMAND_SIGNALS: "supplyDemandDashboardSignals",
  TREND_SIGNALS: "trendDashboardSignals"
};

export const VIEW_ALL_STRATEGY_SIGNALS_LABEL_KEY = "view_all_strategy_signals";

export const AUTOMATIC_STRATEGY_TABLE_DESTINATION = {
  [NOTIFICATION_TYPES.TRANSACTION_STRATEGY_HIGHS_AND_LOWS]: {
    webUrlPattern: "fe.sidDashboardSignalsTab",
    nativeScene: AUTOMATIC_STRATEGY_NATIVE_SCENE.SID_SIGNALS
  },
  [NOTIFICATION_TYPES.TRANSACTION_STRATEGY_SUPPLY_DEMAND]: {
    webUrlPattern: "fe.supplyDemandDashboardSignalsTab",
    nativeScene: AUTOMATIC_STRATEGY_NATIVE_SCENE.SUPPLY_DEMAND_SIGNALS
  },
  [NOTIFICATION_TYPES.DONCHAIN_H4]: {
    webUrlPattern: "fe.trendDashboardSignalsTab",
    nativeScene: AUTOMATIC_STRATEGY_NATIVE_SCENE.TREND_SIGNALS
  },
  [NOTIFICATION_TYPES.TRANSACTION_STRATEGY_TREND]: {
    webUrlPattern: "fe.trendDashboardSignalsTab",
    nativeScene: AUTOMATIC_STRATEGY_NATIVE_SCENE.TREND_SIGNALS
  }
};

export const AUTOMATIC_STRATEGY_LOCKED_SEARCH_FIELDS = ["ticker", "market"];

export function getAutomaticStrategyTableSearch({ ticker, market } = {}) {
  if (!ticker || !market) {
    return null;
  }

  return { ticker, market };
}

export function getAutomaticStrategyTableSearchFromRouteParams(params = {}) {
  return getAutomaticStrategyTableSearch({
    ticker: firstParam(params.ticker),
    market: firstParam(params.market)
  });
}

export function getAutomaticStrategyTableDefaultSettings({
  preview = false,
  ticker,
  market
} = {}) {
  if (preview) {
    return {
      pagination: {
        current: 1,
        rowsPerPage: 8
      }
    };
  }

  const search = getAutomaticStrategyTableSearch({ ticker, market });

  return search
    ? {
        search,
        lockedSettings: AUTOMATIC_STRATEGY_LOCKED_SEARCH_FIELDS
      }
    : {};
}

export function buildAutomaticStrategySignalsHref({
  locale,
  notificationsUniqueId,
  ticker,
  market
} = {}) {
  const destination =
    AUTOMATIC_STRATEGY_TABLE_DESTINATION[notificationsUniqueId];
  const search = getAutomaticStrategyTableSearch({ ticker, market });

  if (!destination || !search) {
    return null;
  }

  const path = UrlProvider.getLocalizedUrl(locale, destination.webUrlPattern, {
    locale
  });

  if (!path) {
    return null;
  }

  return `${path}?${qs.stringify({
    search,
    [LOCKED_SETTINGS_QUERY_KEY]: AUTOMATIC_STRATEGY_LOCKED_SEARCH_FIELDS
  })}`;
}

export function getAutomaticStrategyNativeNavigation({
  notificationsUniqueId,
  ticker,
  market
} = {}) {
  const destination =
    AUTOMATIC_STRATEGY_TABLE_DESTINATION[notificationsUniqueId];
  const search = getAutomaticStrategyTableSearch({ ticker, market });

  if (!destination || !search) {
    return null;
  }

  return {
    scene: destination.nativeScene,
    params: search
  };
}
